
export default function UIInsetsProps(props)
{
	const size = props.size ? props.size : 6;
	let properties = {};
	for (let i = 1; i <= size; i++)
	{
		properties['inset ' + i.toString() + ' type'] = {
			type: 'inset-type',
			default: 'invisible'
		};
		properties['inset ' + i.toString() + ' image'] = {
			type: 'image'
		};
		properties['inset ' + i.toString() + ' audio'] = {
			type: 'audio'
		};
		properties['inset ' + i.toString() + ' video'] = {
			type: 'video'
		};
		properties['inset ' + i.toString() + ' url'] = {
			type: 'url'
		};
		properties['inset ' + i.toString() + ' step'] = {
			type: 'step'
		};
		properties['inset ' + i.toString() + ' camera'] = {
			type: 'camera'
		};
		properties['inset ' + i.toString() + ' title'] = {
			type: 'text'
		};
		properties['inset ' + i.toString() + ' height'] = {
			type: 'numeric',
			default: '100'
		};
		properties['inset ' + i.toString() + ' anchor'] = {
			type: 'inset-anchor',
			default: 'top-left'
		};
	}
	properties.visible = {
		type: 'toggle',
		default: true
	}

	return properties;
}